import axios, { AxiosResponse } from "axios";
import { config } from "../../config";
import { ancillaryOfferPath } from "../paths";
import {
  AncillaryFetchOfferRequest,
  AncillaryFetchOfferResponse,
} from "redmond";

export const getAncillaryOffer = (
  body: AncillaryFetchOfferRequest
): Promise<AncillaryFetchOfferResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res: AxiosResponse<AncillaryFetchOfferResponse> = await axios.post(ancillaryOfferPath, body, {
        baseURL: config.baseURL,
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });

export default getAncillaryOffer;
